import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { OfbizField, OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { ComponentConfig, Lookup } from '../shared/model';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { ViewContainersService } from '../shared/services/view-containers.service';
import { LookUpDialogService } from './look-up-dialog.service';
import {LookupCombo, LOOKUPS as lookupCombos } from './forms';

@Component({
  selector: 'ubs-lookup-dialog-container',
  templateUrl: './lookup-dialog-container.component.html',
  styleUrls: ['./lookup-dialog-container.component.scss'],
  providers:[UbsComponentStoreService]
})
export class LookupDialogContainerComponent implements OnInit {
  @Input() data:any;
  @Input() componentConfig:ComponentConfig;
  lookupForm:OfbizForm;
  /**
   * The name of the lookup form to be used in th lookup
   */
  fieldFormName:string;
  label:string;
  /**
   * Title used in dialog
   */
  title:string;
  /**
   * List of findForms found in the componentConfig
   */
  findForms:OfbizForm[] = [];
  /**
   * List of listForms forund in the componentConfig
   */
  listForms:OfbizList[] = [];
  /**
   * List of lookups found in the componentConfig
   */
  lookups:Lookup[] = [];
  /**
   * 
   */
  lookup:Lookup;
  /**
   * The form to be used in the find/search
   */
  findForm:OfbizForm;
  /**
   * This list containing the search results
   */
  listForm:OfbizList;
  /**
   * Combination of lookup form and result list
   * Used if lookups are not used
   */
  lookupCombo:LookupCombo;

  constructor(
    protected ref:NbDialogRef<LookupDialogContainerComponent>,
    private viewContainersService:ViewContainersService,
    private lookUpDialogService:LookUpDialogService) { }

  ngOnInit(): void {
    console.log({TrackDialog:"LookupDialogContainerComponent",data:this.data,componentConfig:this.componentConfig});
    this.fieldFormName = this.data.lookupOptions.fieldFormName;
    this.label = this.data.label;
    this.title = "Lookup value for "+this.label;
    if(this.componentConfig != undefined && this.componentConfig != null){
      let entries = Object.entries(this.componentConfig);
      let listForms = this.viewContainersService.getForms(entries,this.listForms,"listForm");
      let findForms = this.viewContainersService.getForms(entries,this.findForms,"findForm");
      this.lookups = this.componentConfig.lookups;
      if(this.lookups != undefined){
        this.lookup = this.lookups.find(element => element.fieldFormName = this.fieldFormName);
        this.findForm = findForms.find(element => element.formName == this.lookup.findFormName);
        this.listForm = listForms.find(element => element.listFormName == this.lookup.resultListName);
        this.lookup.requestingField = this.data;
        this.lookup.lookedUpValueFieldName = this.getlookedUpValueFieldName("valueField",this.lookup.requestingField);
        this.lookup.lookedUpDescritionFieldName = this.getlookedUpValueFieldName("descriptionField",this.lookup.requestingField);
        console.log({Lookup:this.lookup});
      }
    }
    /* let entries = Object.entries(this.componentConfig);
    let listForms = this.viewContainersService.getForms(entries,this.listForms,"listForm");
    let findForms = this.viewContainersService.getForms(entries,this.findForms,"findForm");
    this.lookups = this.componentConfig.lookups */;
    if(this.lookups.length < 1 && this.fieldFormName){
      console.log("Doing Lookup combos: ",lookupCombos);
      let lookupCombo:LookupCombo = lookupCombos.find(lookupCombo => lookupCombo.fieldFormName == this.fieldFormName);
      if(lookupCombo != undefined){
        this.lookupCombo = lookupCombo;
        console.log({LookupCombo:lookupCombo});
        this.lookupCombo.requestingField = this.data;
        this.lookupCombo.lookedUpValueFieldName = this.data.lookupOptions.name;
        this.lookupCombo.lookedUpDescritionFieldName = this.data.lookupOptions.descriptionFieldName;
        this.findForm = lookupCombo.lookupForm;
        this.listForm = lookupCombo.lookupList;
      }
    }else{
      console.log("The are fucking lookups: ",this.lookups,this.componentConfig);
    }
    /* if(this.lookups != undefined){
      this.lookup = this.lookups.find(element => element.fieldFormName = this.fieldFormName);
      this.findForm = findForms.find(element => element.formName == this.lookup.findFormName);
      this.listForm = listForms.find(element => element.listFormName == this.lookup.resultListName);
      this.lookup.requestingField = this.data;
      this.lookup.lookedUpValueFieldName = this.getlookedUpValueFieldName("valueField",this.lookup.requestingField);
      this.lookup.lookedUpDescritionFieldName = this.getlookedUpValueFieldName("descriptionField",this.lookup.requestingField);
      console.log({Lookup:this.lookup});
    }else if(this.fieldFormName){
      let lookupCombo:LookupCombo = lookupCombos.find(lookupCombo => lookupCombo.fieldFormName == this.fieldFormName);
      if(lookupCombo != undefined){
        this.lookupCombo = lookupCombo;
        console.log({LookupCombo:lookupCombo});
        this.lookupCombo.requestingField = this.data;
        this.lookupCombo.lookedUpValueFieldName = this.data.lookupOptions.name;
        this.lookupCombo.lookedUpDescritionFieldName = this.data.lookupOptions.descriptionFieldName;
        this.findForm = lookupCombo.lookupForm;
        this.listForm = lookupCombo.lookupList;
      }
    } */
        
  }
  /**
   * 1. Gets the selected lookup value emitted from the find form container
   * 2. Use the internally set requesting field name and create the lookupSelectedValue
   * 3. Sets the lookupSelectedValue observable in the LookupDialgService
   * @param e 
   */
  getLookupSelectedValue(e):void{
    console.log({TrackLookupSelectedValue:e});
    console.log(e["data"]);
    let lookupSelectedValue;
    if(this.lookup != undefined){
      lookupSelectedValue = {
        field:this.lookup.requestingField.name,
        value:e.data[this.lookup.lookedUpValueFieldName],
        description:e.data[this.lookup.lookedUpDescritionFieldName]
      }
      this.lookUpDialogService.setLookupSelectedValue(lookupSelectedValue);
    }else if(this.lookupCombo != undefined){
      let valueField = this.lookupCombo.lookedUpValueFieldName;
      console.log(this.lookupCombo);
      lookupSelectedValue = {
        field:this.lookupCombo.requestingField.name,
        value:e.data[valueField],
        description:e.data[this.lookupCombo.lookedUpDescritionFieldName]
      }
      this.lookUpDialogService.setLookupSelectedValue(lookupSelectedValue);
    }
    
    console.log(lookupSelectedValue);
    //this.dismiss();
    this.ref.close(lookupSelectedValue)
  }

  getlookedUpValueFieldName(fieldType,lookupField:OfbizField):string{
    let fieldName = ""
    let targetParameterList:any[] = lookupField.lookupOptions.targetParameterList;
    if(targetParameterList.length > 0){
      if(fieldType === "valueField"){
        fieldName = targetParameterList[0];
      }else if(fieldType === "descriptionField"){
        fieldName = targetParameterList[1]? targetParameterList[1]:targetParameterList[0];
      }
    }
    return fieldName;
  }

  dismiss(){
    this.ref.close();
  }

}
